<template>
  <div class="liveVidwH5" @click="cameraShow = false">
    <div class="videoPlayBox" ref="videoPlayBox">
      <videoplayer
        ref="videoplayer"
        @liveDataInfo="getLiveDataInfo"
        @giftListSend="getGiftListSend"
        @cameraChange="getCameraChange"
      ></videoplayer>
    </div>
    <div class="tabs-click" :style="{ height: tableHeight + 'px' }">
      <tabsH5
        :liveDataInfo="liveDataInfo"
        :giftListSend="giftListSend"
        :videoBoxHeight= "videoBoxHeight"
      ></tabsH5>
    </div>
    <div class="multiCamera" v-if="cameraShow" @click.stop="cameraShow = true">
      <div class="cameraTitle">
        <div class="videoTitle">多画面</div>
        <div class="closeCamera" @click.stop="cameraShow = false">
          <img src="@/assets/zsLiveImage/h5/close.png" alt="" />
        </div>
      </div>
      <div class="videoContainer">
        <div
          class="videoItem"
          v-for="(item, index) in liveDataInfo.liveActivityFrameEntityList"
          :key="index"
          @click="changeCamera(item, index)"
          :style="{ background: cameraActive == index ? '#F9F3EB' : '#fff' }"
        >
          <div class="videoMessage">
            <div class="frame">画面 {{ index + 1 }}</div>
            <div class="videoStatus" v-if="cameraActive == index">播放中</div>
          </div>
          <div class="coverImage">
            <img :src="getVideoPath(item.liveFrameImage)" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tabsH5 from "./tabsH5.vue";
import videoplayer from "./videoplayer.vue";
import { filePerviewPath } from "@/api/globalApi.js";
export default {
  name: "liveViewH5",
  components: { tabsH5, videoplayer },
  data() {
    return {
      liveDataInfo: {}, // 直播信息
      giftListSend: [],
      cameraShow: false, // 多机位显隐
      cameraActive: 0,
      videoBoxHeight:0,
    };
  },
  computed: {
    tableHeight() {
      this.clientWidth = document.body.clientWidth;
      console.log(this.clientWidth);
      let tableHeight = window.innerHeight - this.videoBoxHeight;

      if (tableHeight < 0) {
        return 0;
      } else {
        return tableHeight;
      }
    },
  },
  created() {
    
    console.log(this.$refs.videoplayer);
  },
  mounted(){
    window.addEventListener('resize', function() {
      document.documentElement.style.height = window.innerHeight + 'px';
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    });
    setTimeout(() => {
      this.videoBoxHeight = this.$refs.videoPlayBox.offsetHeight
    }, 600);
    let url = `/liveViewH5?tvid=${this.$route.query.tvid}&tvType=${this.$route.query.tvType}&webSoleId=${this.$route.query.webSoleId}&liveWhiteSwitch=${this.$route.query.liveWhiteSwitch}&webTenId=${this.$route.query.webTenId}`
    sessionStorage.setItem('url',JSON.stringify(url))
  },
  methods: {
    // 获取用户信息
    getLiveDataInfo(ele) {
      document.title = ele.liveActivityTitle
      this.liveDataInfo = ele;
      if(this.liveDataInfo.liveWhiteSwitch == '1' && !localStorage.getItem('token')){
        this.$router.push(`/excessiveH5?tvid=${this.$route.query.tvid}&tvType=${this.$route.query.tvType}&webSoleId=${this.$route.query.webSoleId}&liveWhiteSwitch=${this.$route.query.liveWhiteSwitch}&webTenId=${this.$route.query.webTenId}`)
      }
    },
    // 获取礼物列表
    getGiftListSend(ele) {
      this.giftListSend = ele;
    },
    // 打开多画面
    getCameraChange(item) {
      console.log(item);
      this.cameraShow = item;
    },
    // 获取视频地址
    getVideoPath(item) {
      return filePerviewPath({ downType: "resource", fileObjId: item });
    },
    // 改变播放画面
    changeCamera(ele, index) {
      this.cameraActive = index;
      this.$refs.videoplayer.source = ele.livePullPath;
    },
  },
};
</script>

<style scoped lang="scss">
@import "./zscmsLiveMixin.scss";
body{
  overflow: hidden;
}
.liveVidwH5 {
  position: relative;
  width: 100%;
  height: 100%;
  font-size: 16px;
  .videoPlayBox {
    width: 100%;
  }
  .tabs-click {
    width: 100%;
    height: 600px;
  }
  .multiCamera {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 300px;
    overflow: hidden;
    box-shadow: -1px -2px 5px 2px #e9e9e9;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    background-color: #fff;
    z-index: 100;
  }
  .cameraTitle {
    display: flex;
    width: 100%;
    height: 56px;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 20px;
    .videoTitle {
      font-weight: bold;
    }
    .closeCamera {
      width: 14px;
      height: 14px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .videoContainer{
    width: 100%;
    height: calc(100% - 56px);
    overflow: hidden;
    overflow-y: auto;
  }
  .videoItem {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 90px;
    box-sizing: border-box;
    padding: 12px 16px;
    .videoMessage {
      width: 60%;
      height: 100%;
      .frame {
        font-weight: bold;
      }
      .videoStatus {
        width: 60px;
        height: 22px;
        text-align: center;
        box-sizing: border-box;
        padding: 0 3px;
        font-size: 14px;
        border-radius: 4px;
        color: #ff5e48;
        font-weight: bold;
        border: 1px solid #f9897a;
        margin-top: 18px;
      }
    }
    .coverImage {
      width: 35%;
      height: 100%;
      border-radius: 8px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  /deep/ .popper__arrow {
    left: 300px;
  }
}

.zs-live-broadcast {
  position: relative;
  height: 233px;
  width: 100%;
  .un-zs-live-broadcast {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 2000;
    background-color: rgba(6, 29, 62, 1);
    overflow: hidden;
  }
}
</style>